import { Text } from "@sundae/ui-toolkit";
import { FC } from "react";

const V3ComparisonStep1: FC = () => {
  return (
    <div className="flex flex-col gap-4">
      <Text tag="p" size="sm">
        Last year, we overhauled the whole SundaeSwap UI to bring you SundaeSwap v2. Now, we present
        SundaeSwap v3.
      </Text>
      <Text tag="p" size="sm">
        SundaeSwap v3 is a complete overhaul of the SundaeSwap smart contracts. Written in Aiken and
        audited by TxPipe, they represent 3 years of innovation and optimization.
      </Text>
      <Text tag="p" size="sm">
        Lets give you a tour of what that means for you!
      </Text>
    </div>
  );
};

export default V3ComparisonStep1;
